import React from 'react';
import styled from 'styled-components';
import { buildListingFullAddress } from 'utils';
import { ListingImage, Title } from 'components';

type ListingSectionProps = {
  listing: {
    line1: string;
    line2?: string;
    thumbnail?: string;
  };
  dataCy?: string;
};

const ListingSection: React.FC<ListingSectionProps> = ({ listing, dataCy }) => {
  const listingAddress = buildListingFullAddress(listing.line1, listing.line2);

  return (
    <ListingSectionContainer data-cy={dataCy}>
      <ListingImage imageSrc={listing.thumbnail} size={24} />
      <TextContainer>
        <AddressText level={4}>{listingAddress}</AddressText>
      </TextContainer>
    </ListingSectionContainer>
  );
};

export default ListingSection;

const AddressText = styled(Title)`
  && {
    font-size: 13px;
    margin-bottom: 0;
  }
`;

const ListingSectionContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TextContainer = styled.div`
  padding-left: 8px;
`;
